<template>
  <div class="fts-automation-node-sequence-label">
    <fts-tippy
      append-content-class="automation-node-sequence-label-tippy-content"
      v-if="module && module.emoji"
    >
      <fts-moji :emoji="module.emoji" :size="14" />

      <fts-label-group
        slot="content"
        :item="{
          emoji: module.emoji,
          name: module.name
        }"
        emoji
        :emoji-size="12"
      />
    </fts-tippy>

    <div class="automation-node-sequence-label__label">
      {{labelName}}
    </div>

    <div class="automation-node-sequence-label__divider" v-if="activity">
      <span class="fts-inline-spacer-2"></span>
      <span>-</span>
      <span class="fts-inline-spacer-2"></span>
    </div>

    <fts-tippy
      append-content-class="automation-node-sequence-label-tippy-content"
      class="automation-node-sequence-label__activity"
      v-if="activity"
    >
      <fts-label-group 
        :item="{
          emoji: activity.emoji,
          name: activity.name
        }" 
        emoji 
        :emoji-size="14" 
      />

      <fts-label-group 
        slot="content" 
        :item="{
          emoji: activity.emoji,
          name: activity.name
        }"
        emoji 
        :emoji-size="12" 
      />
    </fts-tippy>
  </div>
</template>

<script>
import { store as canvasDesignStore } from '../../store/canvasDesignStore';
import commons from '../../commons/commons';

import FTSLabelGroup from '../../elements/FTSLabelGroup';
import FTSMoji from '../../elements/FTSMoji';
import FTSTippy from '../../elements/FTSTippy';

export default {
  props: {
    moduleId: [String, Number],
    activityId: String,
    labelName: String
  },
  components: {
    'fts-label-group': FTSLabelGroup,
    'fts-moji': FTSMoji,
    'fts-tippy': FTSTippy
  },
  data: () => ({
    activity: null
  }),
  methods: {
    async findModuleVariable() {
      const result = await canvasDesignStore.dispatch("findVariable", {
        moduleId: this.moduleId
      });

      if (result) {
        if (this.activityId) {
          let activity = null;
          const standards = Array.isArray(result.standards) ? result.standards : [];
          const activities = Array.isArray(result.activities) ? result.activities : [];
          const findStandard = standards.find(x => x.id == this.activityId);

          if (findStandard) {
            const findStandardInfo = commons.standards.find(x => x.id == this.activityId);

            activity = {
              name: (findStandardInfo && findStandardInfo.name) || findStandard.id
            }
          } else {
            const findActivity = activities.find(x => x.id == this.activityId);

            if (findActivity) {
              activity = {
                emoji: findActivity.emoji,
                name: findActivity.name
              }
            }
          }

          this.activity = activity;
        }
      }
    }
  },
  computed: {
    module() {
      const findModule = canvasDesignStore.getters.workspaceModules.find(x => x.id == this.moduleId);

      if (findModule) {
        return findModule;
      }
    }
  },
  mounted() {
    if (this.moduleId && this.activityId) {
      this.findModuleVariable();  
    }
  }
}
</script>

<style lang="scss">
.fts-automation-node-sequence-label {
  display: flex;
  align-items: center;
  .automation-node-sequence-label__label {
    &:not(:first-child) {
      margin-left: 0.25rem;
    }
  }
  .automation-node-sequence-label__divider {
    flex-shrink: 0;
  }
  .automation-node-sequence-label__activity {
    min-width: 0;
  }
}

.automation-node-sequence-label-tippy-content {
  .fts-label-group {
    .label-group__label {
      color: var(--fts-light);
    }
  }
}
</style>